module.exports = __webpack_public_path__ + "static/media/psIcon.377fd432.svg";